import { createSelector, createSlice } from "@reduxjs/toolkit";
import { setInitialState } from "../../../store/InitialState";

const INITIAL_STATE = setInitialState({
	data: null,
	isFetching: false,
	isSuccess: false,
	isError: false,
	error: null,
});

const fetchAllDocSlice = createSlice({
	name: "fetchAllDocSlice",
	initialState: INITIAL_STATE,
	reducers: {
		fetchAllDocRequest: (state) => {
			state.isFetching = true;
		},
		fetchAllDocSuccess: (state, action) => {
			state.isFetching = false;
			state.isSuccess = true;
			state.data = action.payload;
		},
		fetchAllDocFailuer: (state, action) => {
			state.isFetching = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.payload;
		},
		resetFetchAllDoc: (state) => {
			state.data = null;
			state.error = null;
			state.isError = false;
			state.isFetching = false;
			state.isSuccess = false;
		},
	},
});

export const {
	fetchAllDocRequest,
	fetchAllDocSuccess,
	fetchAllDocFailuer,
	resetFetchAllDoc,
} = fetchAllDocSlice.actions;

export default fetchAllDocSlice.reducer;
